module.exports = __webpack_public_path__ + "static/media/process.16dc2526.svg";